import { IAppState } from 'reducers';

export const selectSending = (state: IAppState) => {
  return state.messages.sending;
};
